var map = {
	"./Administrativo.png": 8347,
	"./CobroPersua.png": 5026,
	"./Constitucionales.png": 4919,
	"./Insolvencia.png": 1546,
	"./Litigios.png": 9,
	"./Mecanismo.png": 1492,
	"./Procesos.png": 5357,
	"./Sancionatorio.png": 3190,
	"./libroFamiliar.png": 6945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3894;